import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '狠狠撸',
    url: 'https://henhenlu.com/',
    description:
      '狠狠撸是您最值得信赖的海量资源聚合搜索平台，提供极速检索、精准匹配、分类浏览等核心功能。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://henhenlu.com/category/xuexi-jiaoyu?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '狠狠撸',
    url: 'https://henhenlu.com/',
    description:
      '狠狠撸 - 海量资源一站式极速搜索平台，提供极速检索、精准匹配、分类浏览',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@henhenlu.com',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '狠狠撸 - 海量资源一站式极速搜索平台',
    description:
      '狠狠撸是您最值得信赖的海量资源聚合搜索平台，提供极速检索、精准匹配、分类浏览等核心功能。',
    url: 'https://henhenlu.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '狠狠撸',
      url: 'https://henhenlu.com/',
    },
  };

  return (
    <>
      <SchemaOrg data={websiteSchema} />
      <SchemaOrg data={orgSchema} />
      <SchemaOrg data={webPageSchema} />

      <HeroSection />
      <StatsSection />
      <CategorySection />
      <FeaturedSection />
      <TestimonialsSection />
      <FAQSection />
    </>
  );
}